import { useState } from 'react';
import { EmployeeReportView } from './EmployeeReportView';
import { ReportRangePicker, rangePreset, type DateRange } from './ReportRangePicker';

/**
 * "My report" — the signed-in employee's own attendance over a chosen period
 * (monthly or a custom range of up to a year): headline metrics, an hours chart,
 * a day-by-day table and CSV/Excel export. Available to everyone who can view
 * their own attendance; managers and HR see all employees under Reports.
 */
export function AttendanceReports() {
    const [range, setRange] = useState<DateRange>(() => rangePreset('thisMonth'));
    return (
        <div className="space-y-4">
            <div className="flex justify-end">
                <ReportRangePicker value={range} onChange={setRange} />
            </div>
            <EmployeeReportView range={range} />
        </div>
    );
}
